export default __webpack_public_path__ + "static/epilogue-ad07099e9f457225c1a0d0dc050bf0e4.svg";